if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      constructor () {
        super()
      }

      connectedCallback () {
        this.adjustSwiper()
      }

      adjustSwiper () {
        if (this.mainSlider && this.querySelectorAll('swiper-slide').length > 1) {
          this.mainSlider.querySelectorAll('swiper-slide').forEach(element => {
            element.classList.remove('hidden')
          });

          Object.assign(this.mainSlider, {
            loop: true,
            navigation: true,
          });

          this.mainSlider.initialize();
        }
      }

      activeMedia (index) {
        this.mainSlider.swiper.slideTo(index)
      }

      get mainSlider() {
        return this.querySelector('.js-media-slider')
      }
    }
  );
}
